<div class="brands-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_BRANDS.DESCRIPTION' | translate }}
    </p>
    <tf-settings-brands-list />
  </div>
</div>
